import { useMemo } from "react";
import { ObjectSchema } from "yup";

import { yupLocalized } from "@ryde/shared";

import { IUserRoleItem } from "./table-user-roles.models";

export const useUserRoleItemResolver = () => {
  const userRoleInnerFormValidationSchema: ObjectSchema<
    Partial<IUserRoleItem>
  > = useMemo(() => {
    return yupLocalized.object<Partial<IUserRoleItem>>().shape({
      roleId: yupLocalized.number().required(),
      siteIds: yupLocalized.array().nullable().optional(),
      supplierIds: yupLocalized.array().nullable().optional(),
      unitIds: yupLocalized.array().nullable().optional(),
      rideTypeIds: yupLocalized.array().nullable().optional(),
    });
  }, []);
  return { userRoleInnerFormValidationSchema };
};
